import React, { useState } from 'react';
import Navbar from '../layout/Navbar';
import { USER_SEARCH_ENDPOINT, USER_STATUS_UPDATE_ENDPOINT } from '../../config/api';
import { decryptData } from '../../utils/encrypt';
import { useNavigate } from 'react-router-dom';

function UserSearch() {
  const [keyword, setKeyword] = useState('');
  const [users, setUsers] = useState([]);
  const [message, setMessage] = useState('');

  const navigate = useNavigate();

  const encrypted = localStorage.getItem('suyog_user');
  const loggedInUser = encrypted ? decryptData(encrypted) : null;

const handleSearch = async (e) => {
  if (e) e.preventDefault();
  setMessage('');
  setUsers([]);

  try {
    const res = await fetch(`${USER_SEARCH_ENDPOINT}?keyword=${encodeURIComponent(keyword.trim())}`);
    const data = await res.json();

    if (res.ok && Array.isArray(data)) {
      if (data.length === 0) setMessage('No users found');
      setUsers(data);
    } else {
      setMessage(data.error || 'Search failed');
    }
  } catch {
    setMessage('Server error');
  }
};

  const toggleUserStatus = async (userId, currentStatus) => {
    if (!loggedInUser?.user_id || !loggedInUser?.user_token) {
      alert('Missing user authentication');
      return;
    }

    try {
      const res = await fetch(USER_STATUS_UPDATE_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          id: userId,
          status: currentStatus === 1 ? 0 : 1,
          user_id: loggedInUser.user_id,
          user_token: loggedInUser.user_token,
        }),
      });

      const data = await res.json();

      if (res.ok) {
        handleSearch();
      } else {
        alert(data.error || 'Failed to update status');
      }
    } catch {
      alert('Server error');
    }
  };

  const viewProfile = (targetId) => {
    if (!loggedInUser?.user_id || !loggedInUser?.user_token) {
      alert('Session expired');
      return;
    }

    navigate(`/user/profile/${targetId}/${loggedInUser.user_id}/${loggedInUser.user_token}`);
  };

  return (
    <>
      <Navbar />
      <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="mb-0">Search Users</h4>
          <a href="/user/new" className="btn btn-success">
            <i className="bi bi-plus-circle me-2"></i>Add New User
          </a>
        </div>

        <form onSubmit={handleSearch} className="mb-3">
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              placeholder="Search by name or phone"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
            />
            <button className="btn btn-primary" type="submit">Search</button>
          </div>
        </form>

        {message && <div className="alert alert-info">{message}</div>}

        {users.length > 0 && (
          <table className="table table-bordered table-striped">
            <thead className="table-dark">
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user, index) => (
                <tr key={user.id}>
                  <td>{index + 1}</td>
                  <td>{user.name}</td>
                  <td>{user.phone}</td>
                  <td>{user.email}</td>
                  <td>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={user.status === 1}
                        onChange={() => toggleUserStatus(user.id, user.status)}
                      />
                      <label className="form-check-label">
                        {user.status === 1 ? 'Active' : 'Inactive'}
                      </label>
                    </div>
                  </td>
                  <td>
                    <button className="btn btn-sm btn-outline-primary" onClick={() => viewProfile(user.id)}>
                      <i className="bi bi-person"></i> Profile
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </>
  );
}

export default UserSearch;
